<!--
 * @Descripttion: 
 * @version: 
 * @Author: mrh
 * @Date: 2019-12-04 18:56:40
 * @LastEditors: mrh
 * @LastEditTime: 2021-01-15 09:57:56
-->
<template>
  <div class="content">
    <!-- <header v-if="isWX != 0">
      <i class="iconfont icon-home_location_icon_l" @click="returnBack"></i>
      <p>悦卖用户协议</p>
    </header> -->
    <!-- <h5-header v-if="isWX != 0" :header-msg="headerMsg"></h5-header> -->
    <!-- <div :class="{mt:isWX == 0,cont:isWX != 0}">
        <frameset>
            <frame src="https://api.yamyamyam.com/mobile/rule.html?source=1" name="view_frame" scrolling="auto">
        </frameset> 
    </div> -->
    <div ref="contentMsg" class="cont"></div>
  </div>
</template>

<script>
import { getActivityRuleContent } from "@/api/picker/index.js";
export default {
  data() {
    return {
        isWX:'1',
        headerMsg: {
          title: "用户协议",
          // url: "/joinup",
        }
    };
  },
  mounted() {
    // this.isWX = this.GetQueryString("wx")
    this.fn_getContent();
  },
  methods: {
    fn_getContent(){
      getActivityRuleContent({
        type: "13", //关注9和10， type 教程类型。2.选菜师教程，3.城市合伙人教程，4.无码商品教程，5：选菜师协议，6：城市合伙人协议，7.选菜师攻略教程，
        //8社区店长攻略，9爆款活动规则,10拼单活动规则，11：打印说明文档,12 店长协议,13悦买用户协议，14悦卖用户协议
      }).then((res) => {
        this.$refs.contentMsg.innerHTML = res.content.content
      });
    }
    // rule(){
    //     console.log('1')
    //     window.open('','_parent')
    // },
    // returnBack(){
    //   this.$router.push({
    //     path: "/joinup",
    //     query: {
    //       type: this.GetQueryString("type"),
    //       refereeId: this.GetQueryString("refereeId")
    //     }
    //   }); //跳转
    // }
  }
};
</script>

<style lang="scss" scoped>
.content {
    height: auto;
    overflow-y: auto;
    overflow-x: hidden;
    width: auto;
    padding: 0 10px;
  .cont{
      height: fit-content;
      margin-top: 10px;
  }
  .mt{
      height: fit-content;
      margin-top: 0
  }
}
</style>
